// extracted by mini-css-extract-plugin
module.exports = {"root":"app-404-components-404-root","title":"app-404-components-404-title","description":"app-404-components-404-description"};